export const CUSTOMER_DETAILS_CHANGE_TRACKING = {
  addressBook: {
    source: 'customer_details.address_book',
    id: 11001,
  },
  collections: {
    source: 'customer_details.collections',
    id: 11002,
  },
  contracts: {
    source: 'customer_details.contracts',
    id: 11003,
  },
  contractsAccessorialBillingInformation: {
    source: 'customer_details.contracts.accessorial_billing_information',
    id: 11040,
  },
  contractsAdditionalLanguage: {
    source: 'customer_details.contracts.additional_language',
    id: 11035,
  },
  contractsAgreementEffectiveDate: {
    source: 'customer_details.contracts.agreement_effective_date',
    id: 11031,
  },
  contractsCountryOfIncorporation: {
    source: 'customer_details.contracts.country_of_incorporation',
    id: 11042,
  },
  contractsCustomerEntityType: {
    source: 'customer_details.contracts.customer_entity_type',
    id: 11043,
  },
  contractsIsCustomerUsEntity: {
    source: 'customer_details.contracts.is_customer_us_entity',
    id: 11044,
  },
  contractsBrokerResponsibilities: {
    source: 'customer_details.contracts.broker_responsibilities',
    id: 11039,
  },
  contractsCarrierBrokerLiability: {
    source: 'customer_details.contracts.carrier_broker_liability',
    id: 11038,
  },
  contractsClaimsAndConcealedDamages: {
    source: 'customer_details.contracts.claims_and_concealed_damages',
    id: 11034,
  },
  contractsIndemnification: {
    source: 'customer_details.contracts.indemnification',
    id: 11041,
  },
  contractsInsurance: {
    source: 'customer_details.contracts.insurance',
    id: 11032,
  },
  contractsOtherCarrierRequirements: {
    source: 'customer_details.contracts.other_carrier_requirements',
    id: 11037,
  },
  contractsTemperatureControlledCommodities: {
    source: 'customer_details.contracts.temperature_controlled_commodities',
    id: 11036,
  },
  contractsTermAndPaymentTerms: {
    source: 'customer_details.contracts.term_and_payment_terms',
    id: 11033,
  },
  edi: {
    source: 'customer_details.edi',
    id: 11004,
  },
  financials: {
    source: 'customer_details.financials',
    id: 11005,
  },
  fuelSurcharge: {
    source: 'customer_details.fuel_surcharge',
    id: 11006,
  },
  general: {
    source: 'customer_details.general',
    id: 11007,
  },
  generalComments: {
    source: 'customer_details.general.comments',
    id: 11010,
  },
  generalContacts: {
    source: 'customer_details.general.contacts',
    id: 11011,
  },
  headerCreditRequest: {
    source: 'customer_details.header.credit_request',
    id: 11012,
  },
  generalCustomerInformation: {
    source: 'customer_details.general.customer_information',
    id: 11013,
  },
  generalTransportation: {
    source: 'customer_details.general.transportation',
    id: 11045,
  },
  headerCustomFields: {
    source: 'customer_details.header.custom_fields',
    id: 11014,
  },
  generalDoNotSolicit: {
    source: 'customer_details.general.do_not_solicit',
    id: 11015,
  },
  generalEmptyLoadReview: {
    source: 'customer_details.general.empty_load_review',
    id: 11016,
  },
  generalOwnership: {
    source: 'customer_details.general.ownership',
    id: 11017,
  },
  generalUploadDocuments: {
    source: 'customer_details.general.upload_documents',
    id: 11018,
  },
  ltlBlockedCarriers: {
    source: 'customer_details.ltl.blocked_carriers',
    id: 11027,
  },
  ltlCarrierSelectionCard: {
    source: 'customer_details.ltl.carrier_selection',
    id: 11028,
  },
  ltlCostPlusMargins: {
    source: 'customer_details.ltl.cost_plus_margins',
    id: 11029,
  },
  ltlCustomerSettingsAndEmailAlerts: {
    source: 'customer_details.ltl.customer_settings_and_email_alerts',
    id: 11030,
  },
  pricing: {
    source: 'customer_details.pricing',
    id: 11009,
  },
  productCatalog: {
    source: 'customer_details.product_catalog',
    id: 11025,
  },
  quotes: {
    source: 'customer_details.quotes',
    id: 11026,
  },
  financialsAdditionalDetails: {
    source: 'customer_details.financials.additional_details',
    id: 11019,
  },
  financialsAddresses: {
    source: 'customer_details.financials.addresses',
    id: 11020,
  },
  financialsCreditTax: {
    source: 'customer_details.financials.credit_tax',
    id: 11021,
  },
  financialsInsurance: {
    source: 'customer_details.financials.insurance',
    id: 11022,
  },
  financialsInvoicing: {
    source: 'customer_details.financials.invoicing',
    id: 11023,
  },
  financialsRequiredDocuments: {
    source: 'customer_details.financials.required_documents',
    id: 11024,
  },
  addressBookCreate: {
    source: 'customer_details.address_book.create',
    id: 11101,
  },
  addressBookDelete: {
    source: 'customer_details.address_book.delete',
    id: 11102,
  },
  addressBookImport: {
    source: 'customer_details.address_book.import',
    id: 11103,
  },
  addressBookUpdate: {
    source: 'customer_details.address_book.update',
    id: 11104,
  },
  collectionsAddComment: {
    source: 'customer_details.collections.add_comment',
    id: 11105,
  },
  collectionsDeleteComment: {
    source: 'customer_details.collections.delete_comment',
    id: 11106,
  },
  collectionsEditComment: {
    source: 'customer_details.collections.edit_comment',
    id: 11107,
  },
  generalUploadDocumentsDelete: {
    source: 'customer_details.general.upload_documents.delete',
    id: 11108,
  },
  generalUploadDocumentsSetDefaultLogo: {
    source: 'customer_details.general.upload_documents.set_default_logo',
    id: 11109,
  },
  generalUploadDocumentsUpload: {
    source: 'customer_details.general.upload_documents.upload',
    id: 11110,
  },
  ediRequestSetup: {
    source: 'customer_details.edi.request_setup',
    id: 11111,
  },
  ediSaveConfiguration: {
    source: 'customer_details.edi.save_configuration',
    id: 11112,
  },
  ediToggleAutoAcceptDecline: {
    source: 'customer_details.edi.toggle_auto_accept_decline',
    id: 11113,
  },
  ediUploadAutoAcceptDecline: {
    source: 'customer_details.edi.upload_auto_accept_decline',
    id: 11114,
  },
  fuelSurchargeDelete: {
    source: 'customer_details.fuel_surcharge.delete',
    id: 11115,
  },
  fuelSurchargeSave: {
    source: 'customer_details.fuel_surcharge.save',
    id: 11116,
  },
  generalCommentsAdd: {
    source: 'customer_details.general.comments.add_comment',
    id: 11117,
  },
  generalCommentsDelete: {
    source: 'customer_details.general.comments.delete_comment',
    id: 11118,
  },
  generalCommentsEdit: {
    source: 'customer_details.general.comments.edit_comment',
    id: 11119,
  },
  headerFlagCreate: {
    source: 'customer_details.header.flag_for_review.create',
    id: 11120,
  },
  headerFlagDelete: {
    source: 'customer_details.header.flag_for_review.delete',
    id: 11121,
  },
  headerFlagUpdate: {
    source: 'customer_details.header.flag_for_review.update',
    id: 11122,
  },
  generalOwnershipRemoveFromWallet: {
    source: 'customer_details.general.ownership.remove_from_wallet',
    id: 11123,
  },
  headerCreditRequestSubmit: {
    source: 'customer_details.header.credit_request.submit',
    id: 11124,
  },
  ltlCspAddAlternateCustomer: {
    source:
      'customer_details.ltl.customer_specific_pricing.add_alternate_customer',
    id: 11126,
  },
  ltlCspCreateScacAccount: {
    source:
      'customer_details.ltl.customer_specific_pricing.create_scac_account',
    id: 11127,
  },
  ltlCspDeleteScacAccount: {
    source:
      'customer_details.ltl.customer_specific_pricing.delete_scac_account',
    id: 11128,
  },
  ltlCspRemoveAlternateCustomer: {
    source:
      'customer_details.ltl.customer_specific_pricing.remove_alternate_customer',
    id: 11129,
  },
  ltlCspUpdateScacAccount: {
    source:
      'customer_details.ltl.customer_specific_pricing.update_scac_account',
    id: 11130,
  },
  productCatalogCreate: {
    source: 'customer_details.product_catalog.create',
    id: 11131,
  },
  productCatalogDelete: {
    source: 'customer_details.product_catalog.delete',
    id: 11132,
  },
  productCatalogImport: {
    source: 'customer_details.product_catalog.import',
    id: 11133,
  },
  productCatalogUpdate: {
    source: 'customer_details.product_catalog.update',
    id: 11134,
  },
  quotesImport: {
    source: 'customer_details.quotes.import',
    id: 11135,
  },
  ltlTestLane: {
    source: 'customer_details.ltl.customer_specific_pricing.test_lane',
    id: 11137,
  },
  pricingToggle: {
    source: 'customer_details.pricing.toggle',
    id: 11138,
  },
  pricingUpload: {
    source: 'customer_details.pricing.upload',
    id: 11139,
  },
  headerCollectionFlagCreate: {
    source: 'customer_details.header.collection_flag.create',
    id: 11140,
  },
  headerCollectionFlagUpdate: {
    source: 'customer_details.header.collection_flag.update',
    id: 11141,
  },
  headerCollectionFlagDelete: {
    source: 'customer_details.header.collection_flag.delete',
    id: 11142,
  },
} as const;
